import ReactModal from "react-modal";
import theme from "../styles/theme";

type Props = {
  isOpen: boolean;
  setOpen: any;
  onDismiss?: () => void;
  onClose?: (courseId: any, section: any) => void;
  children?: any;
  customStyle?: any;
  overlayClassName?: any;
  id?: string;
};

function Modal({
  isOpen,
  setOpen,
  onDismiss,
  onClose,
  children = null,
  customStyle,
  id = "modal",
}: Props): JSX.Element {
  return (
    <>
      <ReactModal
        id={id}
        ariaHideApp={false}
        isOpen={isOpen}
        onRequestClose={() => {
          setOpen(false);
          onClose?.("", "");
          onDismiss && onDismiss();
        }}
        closeTimeoutMS={500}
        style={{
          overlay: {
            zIndex: 9900,
            paddingLeft: theme.spacing.x3,
            paddingRight: theme.spacing.x3,
            background: "rgb(0 0 0 / 43%)",
            overflow: "auto",
            ...customStyle?.overlay,
          },
          content: {
            border: "unset",
            maxWidth: 400,
            background: "rgba(35,37,48,255)",
            color: "#e6e6e6",
            margin: `calc(${theme.navbarHeight} + ${theme.spacing.x3}) auto ${theme.spacing.x4}`,
            position: "static",
            padding: theme.spacing.x2,
            borderRadius: "8px",
            ...customStyle?.content,
          },
        }}
      >
        {children}
      </ReactModal>
    </>
  );
}

export default Modal;
